// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"22b36c58","787":"0047fbaf"}[chunkId] + ".chunk.js";
};